/**
 * OK CAPSULE PACK BUILDER — INJECTED CONTROLS
 * ---------------------------------------------------------------------------
 * Their widget ships no search and no way out to help, and the catalog is 112
 * products deep, so finding anything means scrolling forever. Rather than wait
 * on their roadmap we add two controls above their grid:
 *
 *   1. A search box that filters their rendered product cards by name.
 *   2. A "Chat with Kai" button out to the supplement quiz, for the woman who
 *      does not know what she needs and should not be browsing a catalog.
 *
 * Everything here is additive. We never modify their markup, only hide and
 * show their cards and prepend our own element. If OK Capsule ships real
 * search, delete this file and the one line that loads it in theme.liquid.
 *
 * Loaded only on /a/pack-builder (see layout/theme.liquid).
 */
(function () {
  'use strict';

  var QUIZ_URL = 'https://kai.conceivable.com/';
  var MOUNTED = 'cv-okc-mounted';

  function cardName(card) {
    var el = card.querySelector('.okc-product-name');
    return (el ? el.textContent : card.textContent || '').toLowerCase();
  }

  /** Hide cards that do not match, and any category heading left with none. */
  function applyFilter(term) {
    var q = term.trim().toLowerCase();
    var grids = document.querySelectorAll('.filterProducts--grid');
    var shown = 0;

    document.querySelectorAll('[class*="okc-product-card"]').forEach(function (card) {
      var hit = !q || cardName(card).indexOf(q) !== -1;
      card.style.display = hit ? '' : 'none';
      if (hit) shown++;
    });

    // A category whose products all filtered out should not leave a stray title.
    grids.forEach(function (grid) {
      var any = Array.prototype.some.call(
        grid.querySelectorAll('[class*="okc-product-card"]'),
        function (c) { return c.style.display !== 'none'; }
      );
      grid.style.display = any ? '' : 'none';
      var section = grid.closest('.filterProducts') || grid.parentElement;
      if (section) {
        var title = section.querySelector('.okc-filter-products-title');
        if (title) title.style.display = any ? '' : 'none';
      }
    });

    var empty = document.querySelector('.cv-okc-empty');
    if (empty) empty.style.display = (q && shown === 0) ? '' : 'none';
  }

  function buildTools() {
    var wrap = document.createElement('div');
    wrap.className = 'cv-okc-tools';
    wrap.setAttribute('data-cv-tools', '1');

    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'cv-okc-search';
    input.placeholder = 'Search supplements, try iron or magnesium';
    input.setAttribute('aria-label', 'Search supplements');
    input.addEventListener('input', function () { applyFilter(input.value); });

    var kai = document.createElement('a');
    kai.className = 'cv-okc-kai';
    kai.href = QUIZ_URL;
    kai.textContent = 'Want help? Chat with Kai for personalized recs';

    wrap.appendChild(input);
    wrap.appendChild(kai);

    var empty = document.createElement('div');
    empty.className = 'cv-okc-empty';
    empty.style.display = 'none';
    empty.textContent = 'Nothing matches that. Try a shorter word, or let Kai pick for you.';

    var holder = document.createElement('div');
    holder.appendChild(wrap);
    holder.appendChild(empty);
    return holder;
  }

  /** Their "Show more" is the LAST child of the description container, so our
      height cap clipped it out of existence. Lift it to be a sibling just
      after the container, where nothing clips it. */
  function liftShowMore() {
    document.querySelectorAll('.okc-product-description-more').forEach(function (more) {
      var container = more.parentElement;
      if (!container || container.className.indexOf('okc-product-description-container') === -1) return;
      var desc = container.parentElement;
      if (!desc) return;
      desc.insertBefore(more, container.nextSibling);
    });
  }

  /** Their widget renders async, so wait for the first grid to exist. */
  function mount() {
    if (document.querySelector('[data-cv-tools]')) return true;
    var grid = document.querySelector('.filterProducts--grid');
    if (!grid) return false;
    var anchor = grid.closest('.filterProducts') || grid;
    var host = anchor.parentElement || anchor;
    host.insertBefore(buildTools(), anchor);
    document.documentElement.classList.add(MOUNTED);
    liftShowMore();
    mountFaq();
    return true;
  }

  var FAQ = [
    ['What actually arrives each month?',
     'A roll of daily pouches with your name on them, split into morning and evening. Tear one off, take it, done. No bottles to count.'],
    ['How do I know this combination is safe together?',
     'Before any pack ships it is checked against clinical safety guardrails. If you build with Kai instead, your allergies, medications and where you are in your journey are part of that check.'],
    ['Are these third-party tested?',
     'Yes. Every product in the catalog carries third-party chemistry and microbiology certificates of analysis, and every pack ships with the full supplement facts for what is inside.'],
    ['I do not know what I need. Where do I start?',
     'Take the two minute quiz instead of browsing. It asks about your period, energy and stress, and matches your answers to the nutrients your body is actually asking for.'],
    ['Can I change or cancel?',
     'Yes. Your pack is a monthly subscription you can adjust, pause or cancel anytime.'],
  ];

  function mountFaq() {
    if (document.querySelector('[data-cv-faq]')) return;
    var host = document.querySelector('.products--grid') || document.querySelector('.filterProducts');
    if (!host || !host.parentElement) return;
    var wrap = document.createElement('section');
    wrap.setAttribute('data-cv-faq', '1');
    wrap.className = 'cv-okc-faq';
    var h = document.createElement('h2');
    h.textContent = 'Questions, answered straight';
    wrap.appendChild(h);
    FAQ.forEach(function (qa) {
      var d = document.createElement('details');
      var sm = document.createElement('summary');
      sm.textContent = qa[0];
      var p = document.createElement('p');
      p.textContent = qa[1];
      d.appendChild(sm); d.appendChild(p);
      wrap.appendChild(d);
    });
    var cta = document.createElement('a');
    cta.className = 'cv-okc-kai';
    cta.href = QUIZ_URL;
    cta.textContent = 'Still not sure? Let Kai build it for you';
    cta.style.marginTop = '18px';
    wrap.appendChild(cta);
    host.parentElement.appendChild(wrap);
  }

  function start() {
    if (mount()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (mount()) { mountFaq(); }
      if (tries > 60) clearInterval(timer);   // give up after ~30s
    }, 500);

    // Their app re-renders on category change and can drop our node.
    var obs = new MutationObserver(function () { mount(); liftShowMore(); mountFaq(); });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* Their "Show more" toggles their own state; our height cap would swallow it,
     so mirror the toggle onto the card and let CSS release the cap. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var label = (t.textContent || '').trim().toLowerCase();
    if (label.indexOf('show more') === -1 && label.indexOf('show less') === -1) {
      var near = t.closest('[class*="okc-product-card"]');
      if (!near) return;
    }
    var card = t.closest('[class*="okc-product-card"]');
    if (card && (label.indexOf('show more') !== -1 || label.indexOf('show less') !== -1)) {
      card.classList.toggle('cv-expanded');
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
